module.exports = __webpack_public_path__ + "img/good-session-1.b3aae2b5.png";